import { IEventItem } from '../../../../store/player/events/store';
import { ICheckoutState } from '../EventCheckout/EventCheckout';
import { EventHomeHeights } from './EventHomeHeights';
export const getConfirmHeight = (event: IEventItem, checkout: ICheckoutState) => {
  const activeAddons = event.addons.filter(addon => checkout.selectedAddons[addon.id]).length;
  const { EVENTCHECKOUTBASE, ADDONSHEADER } = EventHomeHeights;
  return activeAddons ? EVENTCHECKOUTBASE + ADDONSHEADER + 48 * activeAddons : EVENTCHECKOUTBASE;
};
